const BookingAddressMixin = {
  data() {
    return {
      currentAddressList: null,
    }
  },
  methods: {
    searchAddressToList(currentAddress) {
      this.currentAddressList = localStorage.currentAddressBookings ? JSON.parse(localStorage.currentAddressBookings) : [];
      return this.currentAddressList.find(address => address == currentAddress.toLowerCase()) ? true : false;
    },
    addToAddressList(address) {
      let hit = this.searchAddressToList(address);

      if (!hit && this.$router.history.current.name !== 'login' && address) {
        this.currentAddressList.push(address.toLowerCase());
        localStorage.currentAddressBookings = JSON.stringify(this.currentAddressList);
      }
    },
    removeAddressToList(currentAddress) {
      this.currentAddressList = localStorage.currentAddressBookings ? JSON.parse(localStorage.currentAddressBookings) : [];

      this.currentAddressList = this.currentAddressList.filter((address) => {
        return address !== currentAddress.toLowerCase();
      });

      localStorage.currentAddressBookings = JSON.stringify(this.currentAddressList);
    },
    removeAllAddress() {
      localStorage.removeItem('currentAddressBookings');
    }
	}
};

module.exports = BookingAddressMixin;